module.exports = __webpack_public_path__ + "img/stat_basic_en.fd2420eb.png";